import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import * as API from '../../framework/API/api';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { utility } from '../../framework/utility/utilityProvider';
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { AUTOMATION, LOCALSTORAGE_KEY } from '../../framework/constant/constant';
import { SchedulingHelper } from '../Scheduling/helper/SchedulingHelper';

const ScheduleExportForm = (props) => {

    const { setFooterMessage } = props;
    const lang = useTranslation();

    const [channels, setChannels] = useState([]);
    const [dataItem, setDataItem] = useState({});

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let channelRes = await API.getValidChannels();
        setChannels(channelRes.data);

        setDataItem({ ...dataItem, channel: utility.getDefaultItem(channelRes.data), date: moment().format('YYYY-MM-DD') });
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const isValid = () => {
        return dataItem.channel && dataItem.date;
    }

    const handleExport = async () => {
        if (!isValid()) return;
        setFooterMessage(lang.please_wait_export_schedule_message);
        const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
        const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
        const offsetTime = offSetHours * 3600000;

        console.log({dataItem , offsetTime});
        
        let scheduleStart = utility.getLocalDateTimeToUtcMiliseconds(new Date(`${dataItem.date}T00:00:00`)) + offsetTime;
        let payload = {
            BookingDate: scheduleStart - offsetTime,
            ScheduleDate: scheduleStart,
            ScheduleEndDate: utility.addTimeToDateInMilliseconds(scheduleStart, 23, 59, 59, 999),
            channelSID: dataItem?.channel?.SID
        }
        await SchedulingHelper.downloadschedule(payload, dataItem?.channel?.Automation?.SID);
        setFooterMessage(lang.successfully_exported_success_message);
    }

    return (
        <div className='row'>
            <div className='col-3 form-group'>
                <label>{lang.channel_label} *</label>
                <DropDownList
                    data={channels}
                    name="channel"
                    textField="FullChannelName"
                    dataItemKey="_id"
                    value={dataItem.channel}
                    onChange={onChange}
                />
            </div>
            <div className='col-2 form-group'>
                <label>{lang.date_label} *</label>
                <input type="date" name="date" className="form-control form-control-sm" value={dataItem.date} onChange={onChange} />
            </div>
            <div className='col mt-4'>
                <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={handleExport} />
            </div>
        </div>
    )
}

export default ScheduleExportForm